import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { FindingCausationClassificationSourceModel, RightShipInspectionInsightModel } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import * as moment from 'moment';
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@transient()
@autoinject
export class BookingRequestsPromptDialog {

    public insights: RightShipInspectionInsightModel[];

    constructor(private dialogClientService: DialogClientService, protected configService: ConfigService) {

    }

    activate(model: { classificationSources: FindingCausationClassificationSourceModel[] })
    {
        this.insights = model.classificationSources.map(item => {
            const causations = [];
            const findings = item.actualCausation.split('|').map(x => x.trim());
            findings.forEach((finding, index) => {
                if (index == 0) {
                    causations.push(`Nature of cause - ${finding}`);
                } else {
                    causations.push(`Subtree ${index + 1} - ${finding}`);
                }
            });
            
            const inspectorComment = item.inspectorComment ? item.inspectorComment : 'No comments provided';
            return {
                rightShipInspectionId: item.rightshipInspectionId,
                description: item.actualFindings,
                comments: [ inspectorComment ],
                findings: causations,
                inspectionDate: this.getFormattedDate(item.inspectionDate),
                causeOfConcern: item.actualCauseofConcern,
                grading: item.questionRiskGrading
            };
        });
    }

    redirectToInspection(rightShipInspectionId: string) {
        window.open(`${this.configService.config.urls.rightShipPlatformUrl}/insp/${rightShipInspectionId}`, "_blank");
    }

    getFormattedDate(date: string): string {
        return moment(date).format('DD MMM YYYY');
    }

    close() {
        this.dialogClientService.hide(true);
    }
}